import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: 'loading.component.html',
    styles: [`
        .loadingComponent {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 24px;
            padding-left: 24px;
            pointer-events: none;
            background-color: rgba(0,0,0,.6);
            transition: background-color .2s ease-in;
            z-index: 5000;
        }
        .loadingLine {
            max-width: 788px;
            flex-grow: 1;
            height: 6px;
            border-radius: 2px;
            background: #F3F5F9;
            z-index: 1;
        }
    `]
})

export class LoadingComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}
